export default __webpack_public_path__ + "static/media/mini-10.ce8b28c7.jpg";